export { default } from './EnergiaSolarFaqBanner';
